import type { PluginObject } from 'vue';

type ChangeTitleFunction = (pageTitle?: string | null) => void;

const ChangeTitlePlugin: PluginObject<null> = {
  install(vue) {
    const changeTitle: ChangeTitleFunction = (pageTitle?: string | null) => {
      if (window?.document) {
        if (pageTitle) {
          window.document.title = `${import.meta.env.VITE_APP_PROJECT_TITLE} \u2013 ${pageTitle}`;
        }
        else {
          window.document.title = import.meta.env.VITE_APP_PROJECT_TITLE;
        }
      }
    };

    vue.prototype.$changeTitle = vue.changeTitle = changeTitle;
  },
};

declare module 'vue/types/vue' {
  interface VueConstructor {
    changeTitle: ChangeTitleFunction
  }

  interface Vue {
    $changeTitle: ChangeTitleFunction
  }
}

export default ChangeTitlePlugin;
